module.exports = __webpack_public_path__ + "img/imx-logo.92ef85f4.png";